import React from "react";
import {SectionContainer, SectionGrid, SectionTitle} from "./options.styles";
import {OptionTile} from "./option-tile";
import {Row} from "antd";

export type OptionType = "product" | "event";

export interface CreateOption {
  id: string;
  type: OptionType;
  label: string;
  description: string;
  borderColor: string;
  bgColor: string;
  tag?: string;
  isComingSoon?: boolean;
  link?: string;
  img: string;
}

interface OptionsGridProps {
  options: CreateOption[];
  title?: string;
  onOptionClick?: (option: CreateOption) => void;
  colors: string[];
  selected?: CreateOption;
}

export const OptionsGrid: React.FC<OptionsGridProps> = ({
  options,
  onOptionClick,
  title,
  colors,
  selected,
}) => {
  if (options.length === 0) return null;

  return (
    <SectionContainer>
      {title && (
        <div
          style={{
            display: "flex",
            gap: "5px",
            alignItems: "center",
            justifyContent: "flex-start",
            marginBottom: "20px",
          }}
        >
          <SectionTitle style={{marginBottom: "0px"}}>{title}</SectionTitle>
          {/* commented dashed line  <div
            style={{
              width: "70%",
              height: "1px",
              border: "1px solid #D9D9D9",
            }}
          ></div> */}
        </div>
      )}
      <Row gutter={[10, 10]}>
        {options.map((option, index) => (
          <OptionTile
            selected={selected && selected?.id === option.id}
            key={option.id}
            option={option}
            index={index}
            onClick={() => onOptionClick && onOptionClick(option)}
            showComingSoon={option.label === "coming soon"}
            colors={colors}
          />
        ))}
      </Row>
    </SectionContainer>
  );
};
